module.exports = __webpack_public_path__ + "media/images/common/2column_product_bg_nnx-24822a879a412f4d355504a44df5d462.png";